import { useMemo } from 'react';

import type { Capability } from '@rtkwlf/capability';

import { hasRequiredCapability } from '../has-required-capability/has-required-capability';
import { useCapabilities } from '../queries/use-capabilities';

export const useHasCapability = (capabilityId: Capability['id']) => {
  const { data: capabilities, ...rest } = useCapabilities();

  const hasCapability = useMemo(
    () => hasRequiredCapability(capabilityId, capabilities),
    [capabilities, capabilityId],
  );

  return {
    hasCapability,
    ...rest,
  };
};
